<template>
  <b-alert
    show
    dismissible
    :variant="alertInfo.variant"
    class="alert-solid alert-label-icon fade show position-fixed start-50 translate-middle-x"
    role="alert"
    style="min-width: 380px; top: 180px;z-index:9999;"
  >
    <i :class="`${alertInfo.icon} label-icon`"></i>
    {{ alertInfo.content }}
  </b-alert>
</template>
<script>
export default {
  props: {
    alertInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          variant: "danger",
          content: "表单校验未通过,请检查表单是否填写完整!",
          icon: "ri-error-warning-line",
        };
      },
    },
  },
};
</script>
